<template>
    <div class="close-header-title">

        <footer>
            <div class="footer-btm footer" :class="{ 'home-footer-only': $route.path === '/' }">
                <div class="container">
                    <div class="footer-content">
                        <div class="copyright-content text-dark">
                            <p>{{ $t('footer.copyright', { year: new Date().getFullYear() }) }}</p>
                        </div>
                        <ul class="footer-links">
                            <li><a href="/privacy-policy">{{ $t('footer.privacy_policy') }}</a></li>
                            <li class="ml-3"><a href="/legal-disclaimer">{{
                                $t('footer.legal_disclaimer') }}</a></li>
                            <li class="ml-3"><a @click="faqclick">{{ $t('footer.faq') }}</a></li>
                            <li class="ml-3"><a @click="aboutus">{{ $t('footer.about_us') }}</a></li>
                            <!-- <li class="ml-3"><a @click="mission">{{ $t('footer.mission') }}</a></li> -->
                            <li class="ml-3"><a @click="contactus">{{ $t('footer.contact_us') }}</a></li>
                            <li class="ml-3"><a @click="blogs">{{ $t('footer.blogs') }}</a></li>
                        </ul>
                        <div class="social-media-buttons">
                            <ul>
                                <li>
                                    <a href="https://www.facebook.com/profile.php?id=61586204880461" target="_blank"
                                        class="social-media-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                            <path
                                                d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" />
                                        </svg>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/vanovy?igsh=dTF3cTkwbHVtcTh2&utm_source=qr"
                                        target="_blank" class="social-media-icon" aria-label="Instagram">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"
                                            role="img">
                                            <path
                                                d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                                        </svg>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.tiktok.com/@vanovy?_t=ZN-90BRRB9MpMs&_r=1"
                                        target="_blank" class="social-media-icon" aria-label="TikTok">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"
                                            role="img">
                                            <path
                                                d="M9 1c.23 1.215 1.104 3.396 3.595 3.558V6.76c-1.135 0-2.178-.345-3.043-.935l-.001 4.013c0 6.696-7.229 6.85-7.229 1.995 0-2.273 1.31-3.478 2.847-3.628.591-.058 1.21.045 1.835.363v1.9c-2.416-.774-3.116.724-2.847 1.62.487 1.645 4.847 2.093 4.847-1.651V1z" />
                                        </svg>
                                    </a>
                                </li>

                                <li>
                                    <a href="https://www.pinterest.com/vanovy" target="_blank"
                                        class="social-media-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
                                            <path
                                                d="M248 8C111 8 0 119 0 256c0 110.5 69.8 204.6 168.3 239.2-2.3-20.3-4.3-51.4 .9-73.5 4.7-20.1 30.5-129.3 30.5-129.3s-7.8-15.6-7.8-38.7c0-36.3 21-63.4 47.1-63.4 22.2 0 33 16.7 33 36.7 0 22.4-14.3 55.9-21.6 86.9-6.1 25.9 13 47 38.6 47 46.3 0 77.5-59.5 77.5-130 0-53.6-36.1-93.8-101.9-93.8-74.4 0-120.9 55.5-120.9 117.5 0 21.4 6.3 36.6 16.1 48.3 4.5 5.3 5.1 7.4 3.5 13.4-1.2 4.4-3.8 15.2-5 19.5-1.6 6.1-6.6 8.3-12.1 6-33.7-13.8-49.4-50.9-49.4-92.5 0-68.8 57.9-151.3 173.2-151.3 92 0 152.6 66.5 152.6 138.1 0 94.6-52.6 165.3-130.1 165.3-26 0-50.5-14.1-58.9-30.1l-16 61.1c-5.8 22.1-17.2 44.2-25.7 59.2 19.3 5.9 39.8 9.1 61.1 9.1 137 0 248-111 248-248S385 8 248 8z" />
                                        </svg>
                                    </a>
                                </li>

                                <li><a href="https://x.com/Vanovy" target="_blank" class="social-media-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                            <path
                                                d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                                        </svg>
                                    </a></li>
                                <li>
                                    <a href="https://www.youtube.com/@Vanovy" target="_blank"
                                        class="social-media-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                            <path
                                                d="M549.7 124.1c-6.3-23.8-24.8-42.4-48.6-48.7C456.5 64 288 64 288 64S119.5 64 74.9 75.4c-23.8 6.3-42.4 24.9-48.6 48.7C15 168.7 15 256 15 256s0 87.3 11.3 131.9c6.3 23.8 24.8 41.5 48.6 47.8C119.5 448 288 448 288 448s168.5 0 213.1-12.3c23.8-6.3 42.4-24 48.6-47.8C561 343.3 561 256 561 256s0-87.3-11.3-131.9zM232 336V176l142 80-142 80z" />
                                        </svg>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <a href="javascript:void(0);" class="scrollup" style="display: none;"><i class="ion-ios-arrow-up"></i></a>

        <!-- Inline SVG Definitions for Testing -->
        <svg style="display: none;">
            <symbol id="icon-facebook" viewBox="0 0 24 24">
                <path
                    d="M22.675 0h-21.35c-0.729 0-1.325 0.597-1.325 1.325v21.351c0 0.729 0.597 1.324 1.325 1.324h11.495v-9.294h-3.123v-3.622h3.123v-2.669c0-3.1 1.894-4.788 4.658-4.788 1.325 0 2.465 0.099 2.797 0.143v3.244l-1.917 0.001c-1.504 0-1.794 0.715-1.794 1.762v2.307h3.588l-0.467 3.622h-3.121v9.294h6.116c0.729 0 1.325-0.595 1.325-1.324v-21.351c0-0.728-0.596-1.325-1.325-1.325z">
                </path>
            </symbol>
            <symbol id="icon-twitter" viewBox="0 0 24 24">
                <path
                    d="M24 4.557c-0.883 0.392-1.832 0.656-2.828 0.775 1.017-0.609 1.798-1.574 2.165-2.724-0.951 0.564-2.005 0.974-3.127 1.195-0.897-0.955-2.173-1.552-3.594-1.552-2.719 0-4.924 2.205-4.924 4.923 0 0.386 0.044 0.763 0.128 1.125-4.091-0.206-7.719-2.165-10.148-5.144-0.423 0.724-0.666 1.562-0.666 2.456 0 1.694 0.863 3.188 2.177 4.066-0.802-0.025-1.558-0.246-2.218-0.614v0.062c0 2.366 1.684 4.342 3.918 4.787-0.41 0.111-0.841 0.171-1.287 0.171-0.314 0-0.615-0.03-0.912-0.086 0.615 1.921 2.397 3.318 4.509 3.356-1.653 1.296-3.734 2.07-5.996 2.07-0.39 0-0.779-0.023-1.17-0.068 2.137 1.373 4.676 2.172 7.404 2.172 8.882 0 13.742-7.355 13.742-13.742 0-0.209-0.004-0.418-0.014-0.626 0.943-0.681 1.762-1.532 2.409-2.505z">
                </path>
            </symbol>
            <symbol id="icon-linkedin" viewBox="0 0 24 24">
                <path
                    d="M4.98 3.5c0 1.382-1.119 2.5-2.5 2.5s-2.5-1.118-2.5-2.5 1.119-2.5 2.5-2.5 2.5 1.118 2.5 2.5zM0.5 23.5v-15h4v15h-4zM8.5 8.5h-0.041c-0.015 0-0.030 0-0.045 0-0.015 0-0.030 0-0.045 0h-0.041v15h4v-8.19c0-1.91 0.347-3.621 2.521-3.621s2.436 1.826 2.436 3.718v8.093h4v-8.666c0-4.373-2.318-6.406-5.423-6.406-2.369 0-3.388 1.325-3.943 2.258v-1.862h-4v0.037z">
                </path>
            </symbol>
            <symbol id="icon-whatsapp" viewBox="0 0 24 24">
                <path
                    d="M12 0c-6.627 0-12 5.373-12 12 0 2.171 0.575 4.214 1.667 6.043l-1.15 4.171 4.296-1.122c1.771 1.037 3.782 1.606 5.937 1.606 6.627 0 12-5.373 12-12s-5.373-12-12-12zM12 21.5c-1.814 0-3.536-0.538-5.006-1.554l-0.362-0.229-2.559 0.668 0.686-2.542-0.228-0.362c-1.014-1.471-1.553-3.194-1.553-5.008 0-5.247 4.253-9.5 9.5-9.5s9.5 4.253 9.5 9.5-4.253 9.5-9.5 9.5z">
                </path>
            </symbol>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'CustomerFooter',
    mounted() {
    },
    methods: {
        faqclick() {
            this.$router.push({ name: 'faq' });
        },
        aboutus() {
            this.$router.push({ name: 'about' });
        },
        contactus() {
            this.$router.push({ name: 'contact' });
        },
        // mission() {
        //     this.$router.push({ name: 'mission' });
        // },
        blogs() {
            window.location.href = 'https://vanovy.com/blogs/';
        }
    }
}
</script>

<style scoped>
.scrollup {
    background-color: #70d3ff;
    color: #fff;
}

.scrollup:hover {
    background-color: #1198ec;
    color: #fff;
}

.goog-te-banner-frame.skiptranslate {
    display: none !important;
}

.footer-content .social-media-buttons ul li .social-media-icon {
    color: #000;
    font-size: 16px;
}

.footer-content .social-media-buttons ul li .social-media-icon:hover {
    color: #1198ec;
}

body {
    top: 0px !important;
}

.goog-te-gadget .goog-te-combo {
    color: black !important;
}

#google_translate_element {
    margin-left: 18px;
}

.skiptranslate.goog-te-gadget {
    font-size: 0;
}

.footer {
    clear: both;
    padding: 22px 0px;
    /* background-color: #363f4d; */
    background-color: #fff;
}

.container:before,
.container:after {
    display: table;
    content: " ";
}

.footer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
}

.footer-content p {
    margin: 0;
}

.footer-content ul {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 0;
    padding: 0;
}

.footer-content ul li a {
    color: #000000;
    cursor: pointer;
    font-weight: 500;
}

.footer-content ul li a:hover,
.footer-content ul li a:hover svg {
    color: #1198ec;
    fill: #1198ec;
}

ul li {
    list-style: none;
}

.social-media-buttons ul li {
    margin-left: 15px;
}

.social-media-buttons ul li svg {
    width: 100%;
    max-width: 16px;
    max-height: 16px;
}

@media (max-width: 574px) {
    .footer-content ul {
        justify-content: center;
        width: 100%;
    }

    .social-media-buttons,
    .copyright-content.text-dark {
        width: 100%;
    }
}
</style>